
// export default 

const Actions = {
    superAdminActions: [
        {
            name: "Company",
            keywords: [ "company", "company logo", "landing page", "policy", "privacy policy", "terms of service", "terms and conditions", "about", "about us", "company info", "organization", "password reset", "account recovery", "reset password", "branding", "company details"],
            route: "Admin.Settings.Company",
            icon: "apartment"
        },
        {
            name: "Roles and Permissions",
            keywords: ["permissions", "roles", "user roles", "access control", "authorization", "permission levels",
            "role management", "super admin", "job admin", "system admin", "admin roles", "access rights", "system", "configuration"],
            route: "Admin.Settings.Permissions",
            icon: "supervised_user_circle"
        },
        {
            name: "All Super Admins",
            keywords: ["super admin", "all super admins", "managers", "system admins", "admin accounts", "admin list",
            "admin users", "access control", "user management"],
            route: "Admin.Settings.Permissions.View.Super.Admins",
            icon: "supervised_user_circle"
        },
        {
            name: "All Job Admins",
            keywords: ["job admin", "all job admins", "recruiter", "recruitment admin", "job manager",
            "job admins", "managers", "admin team", "staff access"],
            route: "Admin.Settings.Permissions.View.Job.Admins",
            icon: "supervised_user_circle"
        },
        {
            name: "Manage Subsidiaries",
            keywords: ["subsidiaries", "sync subsidiary", "linked companies", "branches", "child company", "company structure"],
            route: "Admin.Settings.Subsidiaries",
            icon: "dataset"
        },
        {
            name: "Recruitment Settings",
            keywords: ["preferences", "recruitment", "hiring", "application restrictions", "restrict applications",
            "job application settings", "recruitment policy"],
            route: "Admin.Settings.Recruitment",
            icon: "groups"
        },
        {
            name: "Notifications",
            keywords: ["notifications", "email notifications", "job alerts", "application alerts", "frequency", "notification settings","alert frequency", "update alerts"],
            route: "Admin.Settings.Notifications",
            icon: "notifications"
        },
        {
            name: "Manage Integrations",
            keywords: ["integrations", "auth", "authentication", "social login", "google login", "linkedin login",
            "microsoft teams", "embed code", "api integrations", "oauth", "sso", "developers", "developer tools", "webhook"],
            route: "Admin.Integrations.Settings",
            icon: "webhook"
        },
        {
            name: "Settings",
            keywords: ["settings", "general settings", "configuration", "system settings", "preferences", "permissions", "setup",
            "subsidiaries", "recruitment", "notifications", "roles", "company settings", "retention policy", "retention period", "GDPR Email Template", "General Data Protection Regulation"],
            route: "Admin.Settings.Company",
            icon: "settings"
        },
        {
            name: "Webhook Logs",
            keywords: ["webhook", "webhook logs", "activity logs", "system logs", "logs", "events", "api logs", "callback logs"],
            route: "Admin.Webhook.Logs",
            icon: "webhook"
        },
        {
            name: "GDPR Logs",
            keywords: ["GDPR", "General Data Protection Regulation", "gdpr logs", "email", "consent", "timestamp", "system logs", "logs", "events", "api logs", "callback logs"],
            route: "Admin.GDPR.Logs",
            icon: "webhook"
        },
        {
            name: "Dashboard",
            keywords: ["dashboard", "overview", "home", "homepage", "summary", "main page", "analytics", "admin dashboard"],
            route: "Admin.Dashboard",
            icon: "home"
        },
        {
            name: "All Jobs",
            keywords: ["jobs", "job pool", "all jobs", "view jobs", "job list", "show jobs", "job postings", "open roles"],
            route: "Admin.Job.List",
            icon: "menu"
        },
        {
            name: "All Workflows",
            keywords: ["workflows", "hiring steps", "pipeline", "process", "recruitment stages", "workflow management",
            "steps", "candidate flow"],
            route: "AllWorkflowList",
            icon: "dynamic_feed"
        },
        {
            name: "Create Workflow",
            keywords: ["create workflow", "new workflow", "setup workflow", "workflow stages", "hiring steps", "pipeline"],
            route: "Admin.Create.Workflow",
            icon: "dynamic_feed",
            permissions: "create-workflows"
        },
        {
            name: "Specializations and Tags",
            keywords: ["specializations", "tags", "job tags", "skills", "categories", "job specializations",
            "label", "classification"],
            route: "JobCategorization.Specializations",
            icon: "dataset"
        },
        {
            name: "Create Specialization",
            keywords: ["create specialization", "new specialization", "job specialization", "add specialization", "specialty"],
            route: "JobCategorization.Specializations",
            icon: "dataset",
            permissions: "create-specializations",
            params: "create-specialization"
        },
        {
            name: "Create Tags",
            keywords: ["create tags", "add tags", "job tags", "label", "tag", "skill tags"],
            route: "JobCategorization.Tags",
            icon: "dataset",
            permissions: "create-tags",
            params: "create-tags"
        },
        {
            name: "Talent Pool",
            keywords: ["talent pool", "applicants", "candidates", "interviewees", "staff pipeline", "potential hires",
            "recruitment pool", "candidate list", "shortlisted candidates"],
            route: "Admin.Applicants.AllCandidates",
            icon: "groups",
            permissions: "access-talent-pool"
        },
        {
            name: "Templates",
            keywords: ["templates", "interview templates", "email templates", "message templates", "note templates", "form templates"],
            route: "Admin.Templates.InterviewNotes",
            icon: "forum"
        },
        {
            name: "Create Interview Note",
            keywords: ["create interview note", "interview notes", "interview templates", "note template", "new interview note"],
            route: "Admin.Templates.InterviewNotes.Create",
            icon: "forum",
            permissions: "create-interview-note-templates"
        },
        {
            name: "All Interviews",
            keywords: ["all interviews", "scheduled interviews", "pending feedbacks", "track interviews", "interview date"],
            route: "Scheduled.Interviews",
            icon: "forum",
            permissions: "schedule-interview"
        },
        {
            name: "Unscheduled Candidates",
            keywords: ["unscheduled candidates", "candidates list", "wait time", "stage", "pending"],
            route: "Unscheduled.Candidates",
            icon: "forum",
            permissions: "schedule-interview"
        },
        {
            name: "Departments",
            keywords: ["departments", "job departments", "manage departments", "add department"],
            route: "Admin.Departments",
            icon: "business",
            permissions: "create-department"
        },
        {
            name: "Create Email Template",
            keywords: ["create email template", "email templates", "new email", "compose email", "mail template", "template message"],
            route: "Admin.Templates.Email.Create",
            icon: "forum",
            permissions: "create-email-templates"
        },
        {
            name: "Audit Trail",
            keywords: ["audit trail", "audit", "system logs", "activity history", "log history", "security logs", "trace"],
            route: "Admin.Audit.Trail",
            icon: "apps",
            permissions: "view-audit-trail"
        },
        {
            name: "Create a Job",
            keywords: ["create job", "post job", "new job", "job post", "add job", "job listing", "publish job"],
            route: "/jobs/create/job-details",
            icon: "post_add",
            permissions: "create-job",
            params: "create"
        },
        {
            name: "Add Applicant",
            keywords: ["add applicant", "new applicant", "hire candidate", "staff candidate", "candidate", "applicant entry"],
            route: "Admin.Applicants.AllCandidates",
            icon: "person_add",
            permissions: "add-applicants",
            params: "add-applicant"
        }
    ],
    jobAdminActions: [
        {
            name: "Dashboard",
            keywords: ["dashboard", "overview", "home", "homepage", "summary", "main page", "analytics", "admin dashboard"],
            route: "Admin.Dashboard",
            icon: "home"
        },
        {
            name: "All Jobs",
            keywords: ["jobs", "job pool", "all jobs", "view jobs", "job list", "show jobs", "job postings", "open roles"],
            route: "Admin.Job.List",
            icon: "menu"
        },
        {
            name: "Create a Job",
            keywords: ["create job", "post job", "new job", "job post", "add job", "job listing", "publish job"],
            route: "/jobs/create/job-details",
            icon: "post_add",
            permissions: "create-job",
            params: "create"
        },
        {
            name: "Add Applicant",
            keywords: ["add applicant", "new applicant", "hire candidate", "staff candidate", "candidate", "applicant entry"],
            route: "Admin.Applicants.AllCandidates",
            icon: "person_add",
            permissions: "add-applicants",
            params: "add-applicant"
        }
    ]
}

export default Actions;
